import { useState } from "react";

// Sweet Alert 2
import Swal from "sweetalert2";

// API
import { deleteEmployee } from "../api/employeeApi";

// Model
import { Employee2 } from "../../../../../../model/Employee";

export const useDeleteEmployee = () => {
    const [isLoading, setIsLoading] = useState(false);

    const handleDelete = async (
        employee: Employee2,
        onSuccess?: () => void
    ) => {
        if (isLoading) return;

        Swal.fire({
            title: "Hapus Karyawan",
            text: `Apakah Anda yakin ingin menghapus karyawan ${employee?.nama}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2563EB",
            cancelButtonColor: "#6B7280",
            confirmButtonText: "Hapus",
            cancelButtonText: "Batal"
        }).then(async (result) => {
            if (!result.isConfirmed) return;

            try {
                setIsLoading(true);

                await deleteEmployee(employee);

                await Swal.fire({
                    title: "Berhasil!",
                    text: `Karyawan ${employee?.nama} berhasil dihapus.`,
                    icon: "success",
                });

                onSuccess?.();
            } catch (error) {
                console.error("Error:", error);

                await Swal.fire({
                    title: "Oops!",
                    text: `Terjadi kesalahan saat menghapus karyawan ${employee?.nama}.`,
                    icon: "error",
                });
            } finally {
                setIsLoading(false);
            }
        });
    }

    return {
        isLoading,
        handleDelete
    }
}